import { Injectable } from '@angular/core';
import { EnumTranslatorBase, NewEnumTranslator } from '@skylab-shared/dataModel';
import { Wrapper } from '../wrapper/wrapper';

export { EnumTranslatorBase };

@Injectable({providedIn: 'root'})
@Wrapper(NewEnumTranslator, { static: true })
export class EnumTranslator { }
